/**
 * @generated SignedSource<<1debd4ca0c09177d31f217348efa1444>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachedContentTodo_todo$data = {
  readonly files: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"AttachedContent_files">;
  }>;
  readonly id: string;
  readonly linkedProducts: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"AttachedContent_products">;
  }>;
  readonly " $fragmentType": "AttachedContentTodo_todo";
};
export type AttachedContentTodo_todo$key = {
  readonly " $data"?: AttachedContentTodo_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachedContentTodo_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttachedContentTodo_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AttachedContent_files"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AttachedContent_products"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "1c3bed1740965f9ef368e162cc902d36";

export default node;
